import { render, staticRenderFns } from "./SpeedDate.vue?vue&type=template&id=27f81cf0"
import script from "./SpeedDate.vue?vue&type=script&lang=js"
export * from "./SpeedDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports